import { createSlice } from "@reduxjs/toolkit"
import { stateEnum } from "../constants/enum.js"

const { appMaster } = stateEnum

const initialState = {  
  selectedApp: {},
}  

const appMasterSlice = createSlice({
  name: appMaster,
  initialState,
  reducers: {
    resetAppMaster: (state) => { 
      state.selectedApp = {}
    },
    setSelectedApp: (state, action) => {
      state.selectedApp = action.payload
    },
  }, 
})

export const { resetAppMaster, setSelectedApp } = appMasterSlice.actions
export default appMasterSlice.reducer
